/// <reference path="../../../app.definition.ts" />

interface IContentEditableScope extends angular.IScope {
    textOverflowCallback?: (isOverflow: boolean) => void;
    bckup: string;
}

angular.module('eCareVault.common.directives').directive('contenteditable', ['$sce', function ($sce) {
    return {
        restrict: 'A', // only activate on element attribute
        require: '?ngModel', // get a hold of NgModelController,

        scope: {
            'textOverflowCallback': '='
        },
        link: function (scope: IContentEditableScope, element: angular.IAugmentedJQuery, attrs: angular.IAttributes, ngModel: angular.INgModelController) {
            if (!ngModel) return; // do nothing if no ng-model

            // Specify how UI should be updated
            ngModel.$render = function () {
               // It's better to check if ngModel.$viewValue is a string before calling replace
               const viewValue = ngModel.$viewValue || '';
               ngModel.$setViewValue(viewValue.replace(/(\r\n|\n|\r)/gm, '<br>'));
                element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
                read(); // initialize
            };

            element.on('keyup input', function (event) {
                //Firefox adds a br when we add text then delete it. This caused issue with the placeholder for textbox
                if (element.html().length && !element.text().trim().length) {
                    element.empty();
                }
                const key = event.which || event.keyCode;
                const avoidScroll = (attrs.avoidScroll == "true");
                const el = element.get(0);
                const moreTextAllowed = el.scrollHeight <= el.clientHeight;
                if (element.hasClass('df-textbox') && key == 13) {
                    event.stopPropagation();
                    event.preventDefault();
                    return;
                } else if (!avoidScroll || (avoidScroll && (moreTextAllowed || (!moreTextAllowed && [8, 37, 38, 39, 40].includes(key))))) {
                        scope.$evalAsync(read);
                    }
                    //To restrict the user from entering text that exceeds the height of the textarea provided
                    else {
                        ngModel.$setViewValue(scope.bckup);
                        element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
                        if(!!scope.textOverflowCallback) {
                            scope.textOverflowCallback(true);
                        }
                        event.preventDefault();
                    }

            });

            element.on('paste', (event) => {
                event.preventDefault();
                // Cast the event to ClipboardEvent to access clipboardData
                const clipboardEvent = (event.originalEvent || event) as ClipboardEvent;
                const text = clipboardEvent.clipboardData.getData('text/plain');
                document.execCommand("insertHTML", false, text);
            })

            // Listen for change events to enable binding
            element.on('blur keydown mousedown', function (event) {
                const key = event.which || event.keyCode;
                scope.bckup = ngModel.$viewValue;
                let mx = attrs.maxAllowed;
                //Max-length restriction for textbox
                if (element.hasClass('df-textbox') && (
                    key == 13 || (![1, 8, 37, 38, 39, 40].includes(key) && element.text().trim().length > (mx - 1))
                    )) {
                    event.stopPropagation();
                    event.preventDefault();
                    return;
                }
            });



            // Write data to the model
            function read() {
                let html = element.html();
                // When we clear the content editable the browser leaves a <br> behind
                // If strip-br attribute is provided then by default strip this out
                if (!attrs.stripBr && html == '<br>') {
                    html = '';
                }
               // ngModel.$setViewValue(html);
               //as of now only text value as string is allowed so above line commented and below line added

                //Firefox adds <div> tag for each line while chrome adds <div> tag from second line only.
                //And all the <div> tags except the one occuring at the start of the html should be converted
                //to new line. So removing the first <div> tag in case of firefox browser.
                if(html.indexOf("<div>") == 0){
                    html = html.slice(5);
                }
                const text = html.replace(/<div>/gi, '\n')
                                .replace(/<\/div>/gi, '')
                                .replace(/<p>/, '')
                                .replace(/<p>/gi, '\n')
                                .replace(/<\/p>/gi, '')
                                .replace(/<span>/gi, '\n')
                                .replace(/<\/span>/gi, '')
                                .replace(/<br>/gi, '\n')
                                .replace(/[\s\r\n]+$/, '');

                ngModel.$setViewValue(text);
            }
        }
    };
}]);
